import { DownloadInvoiceDocumentDocument } from '@/api/queries';
import { InvoiceDocumentGenDocumentStatusEnum } from '@/models/gen/graphql';
import graphApi from '@/api';
import runDownloadLatestInvoiceDocument from '@/api/services/invoices/runDownloadLatestInvoiceDocument';
import { saveFile } from '@/utils';
import { searchInvoiceDocumentByInvoiceId } from '@/pages/InvoicePreview/api/services/searchInvoiceDocument';

const [, refetchDownloadInvoiceDocument] = graphApi(DownloadInvoiceDocumentDocument);

const downloadInvoiceDocument = async (invoiceDocumentId: string): Promise<any> => {
  const res = await refetchDownloadInvoiceDocument({
    input: {
      invoiceDocumentId,
    },
  });
  saveFile(res?.downloadInvoiceDocument?.presignedUrl);

  return res?.downloadInvoiceDocument?.presignedUrl;
};

export const downloadLatestInvoiceDocument = async (invoiceId: string | number): Promise<any> => {
  const res = await searchInvoiceDocumentByInvoiceId(invoiceId);
  if (!res?.length) throw new Error('No invoice document found for this invoice');
  const [latestDocument] = res.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  if (!latestDocument) throw new Error('No invoice document found for this invoice');
  // Start Backwards Compatibility: The status will only be null for documents created before the genDocumentStatus was added.
  if (latestDocument.genDocumentStatus === null) {
    const res = await runDownloadLatestInvoiceDocument(Number(invoiceId));
    if (res?.error) throw new Error(res.error.message);
    saveFile(res?.url);
    return res?.url;
  }
  // End Backwards Compatibility
  if (latestDocument.genDocumentStatus !== InvoiceDocumentGenDocumentStatusEnum.Completed)
    throw new Error('Latest invoice document is not ready for download');
  return await downloadInvoiceDocument(latestDocument.id);
};

export default downloadInvoiceDocument;
